const inspectorWorkload = [
    {
        "code":"INS001",
        "name":"王大同",
        "arrangedNumber":10,
        "completedNumber":6,
        "uncompletedNumber":4
    },
    {
        "code":"INS002",
        "name":"王小明",
        "arrangedNumber":12,
        "completedNumber":6,
        "uncompletedNumber":6
    },
    {
        "code":"INS003",
        "name":"吳小華",
        "arrangedNumber":6,
        "completedNumber":0,
        "uncompletedNumber":6
    },
    {
        "code":"INS004",
        "name":"李小玉",
        "arrangedNumber":3,
        "completedNumber":2,
        "uncompletedNumber":1
    },
    {
        "code":"INS005",
        "name":"劉小山 ",
        "arrangedNumber":5,
        "completedNumber":4,
        "uncompletedNumber":1
    }
]

export default inspectorWorkload;